import { useState } from "react";
import { TemplateGrid } from "@/components/templates/TemplateGrid";
import { TemplateBuilder } from "@/components/templates/TemplateBuilder";
import { Button } from "@/components/ui/button";
import { ArrowLeft, Plus, Sparkles } from "lucide-react";
import { useLocation } from "wouter";

export default function Templates() {
  const [, setLocation] = useLocation();
  const [showBuilder, setShowBuilder] = useState(false);

  return (
    <div className="container mx-auto p-6 max-w-7xl">
      <div className="flex items-center justify-between mb-6">
        <Button 
          variant="ghost" 
          onClick={() => setLocation("/")}
          data-testid="button-back-home"
        >
          <ArrowLeft className="h-4 w-4 mr-2" />
          Back to Home
        </Button>
        
        <Button
          onClick={() => setShowBuilder(true)}
          data-testid="button-create-template"
        >
          <Plus className="h-4 w-4 mr-2" />
          Create Template
        </Button>
      </div>

      <div className="mb-8 text-center">
        <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-primary/10 text-primary mb-4">
          <Sparkles className="h-4 w-4" />
          <span className="text-sm font-medium">Pre-built Knowledge Spaces</span>
        </div>
        <h1 className="text-4xl font-bold mb-2">DEEPLY SMART Templates</h1>
        <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
          Start with a fully-loaded template complete with AI agents, topics, prompts, and goals.
          Choose a template below or create your own.
        </p>
      </div>
      
      <TemplateGrid showHeader={false} />
      
      <TemplateBuilder 
        open={showBuilder} 
        onOpenChange={setShowBuilder}
      />
    </div>
  );
}
